function* paramsGenerator({
  filters,
  search,
  delivery_options: deliveryOptions = [],
  sort,
  page,
  favouritesFiltered,
}) {
  for (const key in filters) {
    if (filters[key].length === 0) continue;

    yield [key, filters[key]];
  }

  if (search) yield ['search', search];

  if (deliveryOptions.length) yield ['delivery-options', deliveryOptions];

  if (sort !== 'best-sellers') yield ['_sort', sort];

  if (page !== 1) yield ['_page', page];

  if (favouritesFiltered) yield ['favourited', favouritesFiltered];
}

function generateQueryString(state) {
  const paramsIterator = paramsGenerator(state);

  return Array.from(paramsIterator)
    .map(([key, value]) => {
      return (
        // eslint-disable-next-line prefer-template
        encodeURIComponent(key) +
        '=' +
        []
          .concat(value)
          .map(v => encodeURIComponent(v))
          .join(encodeURIComponent('|'))
      );
    })
    .join('&');
}

export default generateQueryString;
